<template>
    <div class="app-ctn">
        <div class="app-top">
            <div class="p-2 w-fit ml-2 min-h-full">
                <div class="card block items-start justify-center max-w-[300px] mt-2">
                    <!-- <Menu :model="items" class="w-full sidebar">
                        <template #start>
                            <span class="inline-flex items-center gap-1 px-2 py-2 w-full">
                                <img v-if="showLogo && showFavicon" :src="showFavicon"
                                    alt="cyberforceacademy logo" 
                                    class="logo-menu">
                                <img v-else src="../../assets/brand/spec-brand-1.svg" 
                                    alt="cyberforceacademy logo" 
                                    style="height: 80px;">
                                
                            </span>
                        </template>
                        <template #submenulabel="{ item }">
                            <span class="text-primary font-bold">{{ item.label }}</span>
                        </template>
                        <template #item="{ item, props }">
                            <router-link 
                                v-if="item.route && !item.disabled" 
                                :to="item.route" 
                                v-slot="{ isActive, href }" 
                                custom
                            >
                                <a 
                                    v-ripple 
                                    :href="href" 
                                    :class="['flex items-center', { 'active-menu-item': isActive }]" 
                                    v-bind="props.action"
                                >
                                    <span :class="item.icon" />
                                    <span>{{ item.label }}</span>
                                    <Badge v-if="item.badge" class="ml-auto" :value="item.badge" />
                                    <span v-if="item.shortcut" class="ml-auto border border-surface rounded bg-emphasis text-muted-color text-xs p-1">{{ item.shortcut }}</span>
                                </a>
                            </router-link>
                            <a v-else v-ripple class="flex items-center" v-bind="props.action">
                                <span :class="item.icon" />
                                <span>{{ item.label }}</span>
                                <Badge v-if="item.badge" class="ml-auto" :value="item.badge" />
                                <span v-if="item.shortcut" class="ml-auto border border-surface rounded bg-emphasis text-muted-color text-xs p-1">{{ item.shortcut }}</span>
                            </a>
                        </template>
                        
                    </Menu> -->
                    <CFANavOnly/>
                </div>
            </div>
            <div class="side-layout" id="side-layout">
                <div class="navigation p-4 pt-3">
                    <!-- <Menubar  class="border-none nav-hor">
                        
                        <template #end>
                            <div class="flex items-center gap-2 bg-white rounded-md py-2 px-2 h-fit">
                                
                                <Button icon="pi pi-bell" class="p-button-rounded p-button-text hover:bg-gray-100 transition-colors" />
                                
                                
                                <div class="relative flex gap-2 items-center">
                                    <Avatar 
                                        :image="userData?.image_url || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'"
                                        shape="circle" 
                                        class="cursor-pointer hover:ring-2 hover:ring-primary transition-all"
                                        @click="toggleProfileMenu" 
                                        aria-haspopup="true"
                                        aria-controls="profile_menu"
                                    />
                                    <p class="text-sm font-medium">{{ userData?.firstname }} {{ userData?.lastname }}</p>
                                    
                                    
                                    <TieredMenu 
                                        id="profile_menu"
                                        ref="profileMenu" 
                                        :model="profileItems" 
                                        :popup="true" 
                                        :autoZIndex="true"
                                        class="w-48"
                                    />
                                </div>
                            </div>
                        </template>
                    </Menubar> -->
                    <CFANavTop/>
                </div>
                <div class="w-full">
                    <router-view/>
                </div>
            </div>
        </div>
        <CFANavBottom/>
    </div>
</template>

<script setup>
/* eslint-disable */
import { ref, onMounted } from "vue";
import { useI18n } from 'vue-i18n';
//import { getAPI } from '@/axios-api.js';
import { fetchUserSubscription } from '@/services/subscriptionService';
import { fetchUserData } from '@/services/accountService';
import Badge from "primevue/badge"
import Menu from "primevue/menu"
import Menubar from "primevue/menubar"
//import InputText from "primevue/inputtext"
import Button from "primevue/button"
import Avatar from "primevue/avatar"
import TieredMenu from "primevue/tieredmenu";
import CFANavOnly from "../nav/CFANavOnly.vue";
import CFANavTop from "../nav/CFANavTop.vue";
import CFANavBottom from "../nav/CFANavBottom.vue";
const { t } = useI18n();
const items = ref([
    {
        separator: true
    },
    {
        label: t('sidebar.dashboard'),
        icon: 'pi pi-home',
        route: '/dashboard'
    },
    {
        label: t('sidebar.modules'),
        icon: 'pi pi-book',
        route: '/modules'
    },
    {
        label: t('sidebar.exam'),
        icon: 'pi pi-question-circle',
        route: '/certificate-exam',
        //disabled: true
    },
    {
        label: t('sidebar.certificate'),
        icon: 'pi pi-verified',
        route: '/mon-certificat'
    },
    {
        separator: true,
        visible: viewFilter(['organisation'])
    },
    {
        label: t('sidebar.microlearn'),
        icon: 'pi pi-file',
        route: '/microlearn',
        visible: viewFilter(['organisation'])
    },
    {
        label: t('sidebar.audit'),
        icon: 'pi pi-shield',
        route: '/audits',
        visible: viewFilter(['organisation'])
    },
    {
        separator: true,
        visible: viewFilter(['organisation'])
    },
    {
        label: t('sidebar.follow'),
        icon: 'pi pi-chart-line',
        route: '/suivi-utilisateurs',
        visible: viewFilter(['organisation'])
    },
    {
        label: t('sidebar.manage'),
        icon: 'pi pi-users',
        route: '/gestion-utilisateurs',
        visible: viewFilter(['organisation'])
    },
    {
        label: t('sidebar.enterprise'),
        icon: 'pi pi-building',
        route: '/entreprise',
        visible: viewFilter(['organisation'])
    },
    {
        separator: true
    },
    {
        label: t('sidebar.settings'),
        icon: 'pi pi-cog',
        route: '/parametres'
    },
    {
        label: t('sidebar.help'),
        icon: 'pi pi-question-circle',
        route: '/support-service'
    },
    {
        label: t('sidebar.logout'),
        icon: 'pi pi-sign-out',
        style: 'color: red'
    }
]);

// Add this function to check visibility based on account type
function viewFilter(array) {
    const typeAccount = localStorage.getItem('type_account');
    return array.includes(typeAccount);
}

// Navigation items for the horizontal menubar
const navItems = ref([
    {
        label: t('nav.home'),
        icon: 'pi pi-fw pi-home'
    },
    {
        label: t('nav.courses'),
        icon: 'pi pi-fw pi-book',
        items: [
            {
                label: t('nav.all_courses'),
                icon: 'pi pi-fw pi-list'
            },
            {
                label: t('nav.my_courses'),
                icon: 'pi pi-fw pi-bookmark'
            }
        ]
    },
    {
        label: t('nav.reports'),
        icon: 'pi pi-fw pi-chart-bar'
    },
    {
        label: t('nav.resources'),
        icon: 'pi pi-fw pi-file'
    }
]);

// Add this with your other refs
const profileMenu = ref(null);

// Define menu items for the profile dropdown
const profileItems = ref([
    {
        label: t('sidebar.settings'),
        icon: 'pi pi-cog',
        command: () => window.location.href = '/parametres'
        //route: '/parametres'

    },
    {
        label: t('sidebar.facture'),
        icon: 'pi pi-credit-card',
        command: () => window.location.href = '/facturation'
    },
    {
        separator: true
    },
    {
        label: t('sidebar.logout'),
        icon: 'pi pi-sign-out',
        class: 'text-red-600',
        command: () => handleLogout()
    }
]);

// Update the toggle function to use PrimeVue's built-in show method
const toggleProfileMenu = (event) => {
    profileMenu.value.toggle(event);
};

// Add a logout handler function
const handleLogout = () => {
    // Add your logout logic here
    console.log('Logging out...');
};
const showProfileMenu = ref(false);

const showLogo = ref(null);
const showFavicon = ref(null)
const userData = ref(null);
// Ajoutez cette fonction pour récupérer les informations de l'organisation
// Remplacez la fonction retrieveUserSubscription par ceci
const retrieveUserSubscription = async () => {
    try {
        const result = await fetchUserSubscription();
        if (result.data) {
            showLogo.value = result.data.organisation.logo;
            showFavicon.value = result.data.organisation.favicon;
        }
        const userResult = await fetchUserData();
        if (userResult.data) {
            userData.value = userResult.data;
        }
    } catch (error) {
        console.error('Error fetching subscription data:', error);
    }
};

// Appelez cette fonction lors du montage du composant
onMounted(() => {
    retrieveUserSubscription();
    
    // Gardez le code existant pour fermer le menu du profil
    document.addEventListener('click', (e) => {
        const profileMenu = document.querySelector('.relative');
        if (profileMenu && !profileMenu.contains(e.target) && showProfileMenu.value) {
            showProfileMenu.value = false;
        }
    });
});
</script>

<style lang="scss">
    @import "../../assets/scss/app/styles.scss";
    
    .app-top {
        // background-color: $accent-color; /* Fallback for older browsers */
        background: linear-gradient(to bottom, var(--primary-color) 0px, var(--primary-color) 320px, white 100px, white 100%);
        .logo-menu {
            width: 100%;
            //height: 80px;
            object-fit: contain;
            border-radius: 6px;
        }
    }
    .sidebar {
    }
    .p-menu {
        .p-menu-separator {
            &:not(:first-child) {
                @apply bg-gray-500 my-6;
            }
            &:first-child {
                @apply mb-6;
            }
        }
    }
    .navigation { 
        .p-menubar { 
            @apply rounded-none py-2 px-4 bg-transparent border-none shadow-none;
            
            .p-menubar-root-list { 
                @apply ml-4;
            }
            
            .p-menuitem-link { 
                @apply py-3 px-4;
                
                &:hover { 
                    @apply bg-gray-100/40;
                } 
            } 
        } 
    }
    
    /* Add active menu item styling */
    .active-menu-item {
        // background-color: $accent-color;
        color: white !important;
        border-radius: 4px;
    }

    .side-layout {
        width: 100%;
        padding-bottom: 200px;
        @media (min-width: 1024px) {
            max-width: calc(100% - 300px);
        }
        &-wide {
            @media (min-width: 1024px) {
                max-width: calc(100% - 100px);
            }
        }
    }
</style>